import VidConf from './vidConf';
import JoinRoom from './joinRoom';
import NDA_URL_Key from '../middleware/URL_key';
import React, {useRef, useEffect} from 'react';
import { selectPeers, 
    selectIsConnectedToRoom,
    useHMSActions,
    useHMSStore } from "@100mslive/react-sdk";

let meetings = require('../seeders/seedMeetings.json');
// let canvas = React.createRef();

const NDAER_URL_NGROK = "https://86a2-2600-1700-6450-4000-e90b-7ad6-121e-da45.ngrok.io/documents"
//todo !!!!!!!!!v Toggle before push v!!!!!!!!!
//!----v here('dev','dep') v--------
const NDAER_URL =  NDA_URL_Key('dep',0)
//!----^ here ^--------
  // const NDAER_URL =  "http://localhost:3000/nda?id=0"
//!todo-------- Make to where its specific doc_id for meeting
  // const NDAER_URL =  "https://ndaer.netlify.app/nda?id=0"
// !!!!!!!!!^ Toggle before push ^!!!!!!!!!
//todo convert to dynamic link generated by api based on roles for each meeting
const Guest_vid = "https://townhall.app.100ms.live/meeting/ymm-jmt-lsr"

//  let el2
function Ndaer(props) {
const peers = useHMSStore(selectPeers);
const isConnected = useHMSStore(selectIsConnectedToRoom);
const hmsActions = useHMSActions();
  function routeHome(){
    window.location.href = `/`
  }
  console.log("process.env.NDAER_URL",process.env.NDAER_URL)
  // }, []);
  
    return (
        <div className="test_container center">
         <iframe src={NDAER_URL} width="100%" height="100%" id="test_iframe" > 
        {/*<iframe src={Guest_vid} width="267px" height="517px" id="test_iframe" allow="camera;microphone">*/}
            </iframe>
{/* {isConnected && (
            <button
            id="leave-btn"
            className="btn-danger"
            onClick={() => hmsActions.leave()}
            >
            Leave Room
            </button>
        )}
    
        {isConnected ?  <VidConf /> : <JoinRoom />} */}
        
      </div>

  );
}
export default Ndaer; 